// Copyright © 2022 Vewd Software AS.
//
// This file is part of Vewd Cloud,
// and includes Vewd Confidential Information.
// Distribution is strictly prohibited without Vewd's written consent.
import { useParams } from "react-router-dom";

import { Loader } from "components/elements/Loader";
import { PageHeader, PageContent, SubTabs, SubTab } from "components/layout";
import { ALL_PROVIDERS, RestrictedArea } from "containers/Permissions";
import { useSnapApplication } from "hooks/snap";
import {
  useSnapState,
  ERRORS,
  MESSAGES,
  STATES,
  InfoBox,
} from "pages/Snap/_shared";
import { parseInitialSnapData } from "pages/Snap/SnapEdit/adaptData";

import { SnapApplicationDetails } from "./SnapApplicationDetails";

export function SnapApplicationDetailsTabs() {
  const { id, tabId } = useParams();
  const { appStates, getRevision, isNew, loading } = useSnapState();
  const { data: appData, error } = useSnapApplication(id);

  const findTabId = (tabId) => {
    const id = tabId.toUpperCase();

    if (isNew) {
      return null;
    }
    return appStates.map(({ key }) => key).includes(id)
      ? id
      : appStates[0]?.key;
  };

  const generateTabUrl = (tabId) =>
    `/snap/${id}/details/${tabId.toLowerCase()}`;

  const dataReady = !loading && appData;
  const currentTab = loading ? null : findTabId(tabId);

  return (
    <>
      <PageHeader>{dataReady ? appData?.name : ""}</PageHeader>
      <PageContent>
        <RestrictedArea allowed={ALL_PROVIDERS}>
          {!dataReady && !error && <Loader />}
          {dataReady && currentTab && (
            <SubTabs>
              {appStates.length &&
                appStates.map(({ key }) => {
                  return (
                    <SubTab
                      key={key}
                      to={generateTabUrl(key)}
                      text={STATES[key]}
                      active={key === currentTab}
                    />
                  );
                })}
            </SubTabs>
          )}
          {dataReady && currentTab && (
            <SnapApplicationDetails
              appId={id}
              revision={parseInitialSnapData(getRevision(currentTab))}
              revisionType={currentTab}
            />
          )}
          {error && <InfoBox message={MESSAGES.genericError} type="error" />}
          {dataReady && isNew && (
            <InfoBox message={ERRORS.NO_REVISION_AVAILABLE} type="error" />
          )}
        </RestrictedArea>
      </PageContent>
    </>
  );
}
